export const hasBalancePayment = (booking) =>
  Number(booking?.referralCreditAppliedCents || 0) > 0 &&
  booking?.referralCreditDeducted === true;

export const bookingPriceLabel = (booking, formatPrice, freeLabel = "Kostenfrei") => {
  const priceCents = Number(booking?.priceCents || 0);
  if (hasBalancePayment(booking)) {
    return priceCents === 0
      ? "Mit Guthaben bezahlt"
      : `${formatPrice(priceCents)} (teilweise mit Guthaben bezahlt)`;
  }
  if (priceCents === 0 && booking?.paymentMethod === "voucher") {
    return "Mit Gutschein bezahlt";
  }
  if (priceCents === 0 && booking?.status === "cancelled" &&
      Number(booking?.referralCreditAppliedCents || 0) > 0) {
    return "Guthaben zurückerstattet";
  }
  return priceCents === 0 ? freeLabel : formatPrice(priceCents);
};
